export class RetryableError extends Error {
  constructor(message) {
    super(message)
    this.name = "RetryableError"
  }
}

export class RefreshableError extends Error {
  constructor(message) {
    super(message)
    this.name = "RefreshableError"
  }
}
